import React from 'react'
import { useInView } from 'react-intersection-observer'

function Feature({elem }) {
  const {inView , ref} = useInView()
  return (
    <div ref={ref}  className="feature">
        <img className='feature__img' src={elem.url} />
        <div className="feature--content">
            <h2 className="content-title">
                {elem.title}
            </h2>
            <p className='feature--content__description'>
                {elem.description}
            </p>
        </div>
    </div>
  )
}

export default Feature